/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface RechercheImpressionSearch
 */
export interface RechercheImpressionSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheImpressionSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheImpressionSearch
     */
    description?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof RechercheImpressionSearch
     */
    computedActif?: BooleanSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheImpressionSearch
     */
    rapport?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheImpressionSearch
     */
    module?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheImpressionSearch
     */
    acces?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheImpressionSearch
     */
    centre?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof RechercheImpressionSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RechercheImpressionSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheImpressionSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheImpressionSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RechercheImpressionSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RechercheImpressionSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RechercheImpressionSearch interface.
 */
export function instanceOfRechercheImpressionSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RechercheImpressionSearchFromJSON(json: any): RechercheImpressionSearch {
    return RechercheImpressionSearchFromJSONTyped(json, false);
}

export function RechercheImpressionSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RechercheImpressionSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'description': !exists(json, 'description') ? undefined : TextSearchFromJSON(json['description']),
        'computedActif': !exists(json, 'computedActif') ? undefined : BooleanSearchFromJSON(json['computedActif']),
        'rapport': !exists(json, 'rapport') ? undefined : TextSearchFromJSON(json['rapport']),
        'module': !exists(json, 'module') ? undefined : TextSearchFromJSON(json['module']),
        'acces': !exists(json, 'acces') ? undefined : TextSearchFromJSON(json['acces']),
        'centre': !exists(json, 'centre') ? undefined : TextSearchFromJSON(json['centre']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RechercheImpressionSearchToJSON(value?: RechercheImpressionSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'description': TextSearchToJSON(value.description),
        'computedActif': BooleanSearchToJSON(value.computedActif),
        'rapport': TextSearchToJSON(value.rapport),
        'module': TextSearchToJSON(value.module),
        'acces': TextSearchToJSON(value.acces),
        'centre': TextSearchToJSON(value.centre),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

